import * as React from 'react';
import ViewWrapper from './ViewWrapper/ViewWrapper';
import ViewHeading from './ViewHeading/ViewHeading';
import { getData, getDataBy, deleteRow } from '../actions/apiCall';
import {
  Table,
  Modal,
  Button,
  Space,
  Dropdown,
  Menu,
  Input,
  Select,
  DatePicker,
  Drawer,
  notification,
  List,
} from 'antd';

import {
  DownOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  EyeTwoTone,
} from '@ant-design/icons';
import SimpleForm from './Simple-form';
import { Image } from 'antd';
import axios from 'axios';

const { Search } = Input;

const { RangePicker } = DatePicker;
const { confirm } = Modal;
interface Props {
  dispatch?: any;
  object?: any;
  history?: any;
  children?: any;
  user?: any;
  match?: any;
  component?: any;
}

interface Sates {
  visible: boolean;
  loading: boolean;
  onSubmit: any;
  searchText: any;
  searchedColumn: any;
  columnData: any;
  pagination: any;
  isLoading: boolean;
  id: any;
  apiData: any;
  selectedValue: any;
  isView?: boolean;
  actionType?: any;
  visiblePDF?: any;
  visibleText?: any;
  htmlText: any;
  file?: any;
  mailSending?: boolean;
  buttonVisible?: boolean;
  filterdArray?: any;
  buttonText?: any;
  keyDisabled?: any;
  isButtonHide?: boolean;
  filterVisible?: any;
  fixFilterData?: any;
  isImportVisible?: any;
  isCoponentView?: any;
}

class BaseComponent extends React.PureComponent<Props, Sates> {
  config: any;
  submitForm: any;
  submitImportForm: any;
  submitFilterForm: any;
  searchInput: any;
  DaynamicCompoent: any;
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      onSubmit: false,
      searchText: '',
      searchedColumn: '',
      columnData: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      isLoading: true,
      id: false,
      apiData: {},
      selectedValue: [],
      isView: false,
      actionType: 'Add',
      visiblePDF: false,
      file: null,
      visibleText: null,
      htmlText: null,
      mailSending: false,
      buttonVisible: false,
      filterdArray: [],
      buttonText: null,
      keyDisabled: false,
      filterVisible: false,
      isImportVisible: false,
      fixFilterData: {},
      isCoponentView: false
    };
  }

  callAPI = async (routes, method) => {
    if (method == 'get') {
      const funtionCall = getData(routes, {});
      const resData = await this.props.dispatch(funtionCall);
      if (resData) {
        notification.success({
          message: 'Successfully done',
          description: 'Request executed successfully'
        });
      }
    }
  };

  getResponse = async (filter = {}) => {
    this.setState({ isLoading: true });
    axios.defaults.headers.common['permissions'] = JSON.stringify(
      this.getAccess()
    );
    const funtionCall = getData(this.config.api(), { ...filter, ...this.state.fixFilterData });
    const responseData = await this.props.dispatch(funtionCall);
    const { data, pagination } = responseData;
    this.setState({
      columnData: data,
      pagination: pagination,
      isLoading: false,
    });
    return responseData;
  };

  getRecordsById = async (id: any, isView = false) => {
    const data: any = await this.props.dispatch(
      getDataBy(`${this.config.api()}/${id}`)
    );
    this.setState({ id, apiData: data.data });
    this.props.dispatch({
      apiData: data.data,
      formData: data.data,
      type: 'USER_FORM_DATA',
    });
    this.showModal(isView);
  };

  showModal = (isView = false) => {
    this.setState({
      isView,
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: false, visible: false, id: false, apiData: {} });
    this.getResponse();
  };

  handleCancel = () => {
    this.setState({ visible: false, id: false, apiData: {} });
  };

  handleFilterCancel = () => {
    this.setState({ filterVisible: false });
  };

  handleImportCancel = () => {
    this.setState({ isImportVisible: false });
  };

  onSubmitForm = (submitForm) => {
    this.submitForm = submitForm;
  };

  onSubmitImport = (value) => {
    console.log('valuevaluevalue');
    this.submitImportForm = value;
  };

  onSubmitFilterForm = (_submitForm) => {
    // this.submitFilterForm = submitForm;
  };

  onFilterForm = (submitForm) => {
    this.submitFilterForm = this.removeBlankOrNullValues(submitForm);
  };

  removeBlankOrNullValues = (obj) => {
    const result = {};
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        result[key] = obj[key];
      }
    }
    return result;
  };


  showNotification = (type, msg, disc) => {
    notification[type]({
      message: msg,
      description: disc,
    });
  };

  refreshData = async (id: any, isView = false) => {
    console.log(isView);
    const data: any = await this.props.dispatch(
      getDataBy(`${this.config.api()}/${id}`)
    );
    this.setState({ id, apiData: data.data });
    this.props.dispatch({
      apiData: data.data,
      formData: data.data,
      type: 'USER_FORM_DATA',
    });
  };

  sendMail = async () => {
    this.setState({ mailSending: true });
    const data = await this.props.dispatch(
      getData(this.config.extraCall(this.state.id))
    );
    console.log('data', data);
    if (data) {
      this.showNotification('success', 'Success', 'Mail Sent Successfully');
      this.setState({ mailSending: false });
      this.refreshData(this.state.id);
    } else {
      this.showNotification('error', 'Error', 'Faild to sent mail');
    }
  };

  getCompleteUrl = (filePath) => {
    const baseUrl = process.env.FILE_URL;
    if (filePath && typeof filePath === 'string') {
      if (!filePath.startsWith(baseUrl)) {
        return `${baseUrl}${filePath}`;
      }
    }
    return filePath;
  };

  openPDF = () => {
    const { visiblePDF, file, apiData, buttonText, keyDisabled, isButtonHide } = this.state;
    const { maskClosable } = this.config;
    const access = this.getAccess();
    const footerButtons = [];
    if (!isButtonHide && access.edit && this.state.buttonVisible && this.checkAprovalSendMail(apiData)) {
      footerButtons.push(
        <Button
          key={apiData._id}
          loading={this.state.mailSending}
          disabled={apiData.invoiceSent || (keyDisabled && apiData[keyDisabled])}
          onClick={() => this.sendMail()}
          className="mr-2"
          type="primary"
        >
          {buttonText ? buttonText : 'Send to Mail'}
        </Button>
      );
    }
    return (
      <>
        <Modal
          maskClosable={maskClosable}
          width={'100%'}
          style={{ top: 20, bottom: 20 }}
          open={visiblePDF}
          destroyOnClose={true}
          title="View"
          className="pdf-viewer"
          onCancel={() => this.setState({ visiblePDF: false })}
          footer={[
            ...footerButtons,
            <Button
              key="back"
              onClick={() => this.setState({ visiblePDF: false })}
              className="mr-2"
            >
              Cancel
            </Button>,
          ]}
        >
          <iframe
            src={this.getCompleteUrl(file)}
            onLoad={() => 'null'}
            title="myframe"
            id="myFrame"
            width="100%"
            style={{ height: '100%' }}
            allowFullScreen
          ></iframe>
        </Modal>
      </>
    );
  };

  viewText = () => {
    const { visibleText, htmlText } = this.state;
    const { maskClosable } = this.config;

    return (
      <>
        <Modal
          maskClosable={maskClosable}
          visible={visibleText}
          destroyOnClose={true}
          title="View"
          onCancel={() => this.setState({ visibleText: false })}
          footer={[
            <Button
              key="back"
              onClick={() => this.setState({ visibleText: false })}
              className="mr-2"
            >
              Cancel
            </Button>,
          ]}
        >
          {htmlText && Array.isArray(htmlText) ? this.getList(htmlText) : <div dangerouslySetInnerHTML={{ __html: htmlText }}></div>
          }
        </Modal>
      </>
    );
  };

  getModal = () => {
    const { visible, loading, id } = this.state;
    const { maskClosable, modalTitle } = this.config;
    return (
      <>
        <Drawer
          maskClosable={maskClosable}
          width={1000}
          title={modalTitle(this.state.actionType)}
          placement="right"
          onClose={this.handleCancel}
          open={visible}
          destroyOnClose={true}
          footer={
            this.state.isView
              ? null
              : [
                <Button
                  key="back"
                  onClick={this.handleCancel}
                  className="mr-2"
                >
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  loading={loading}
                  onClick={() => {
                    this.submitForm();
                  }}
                >
                  Save
                </Button>,
              ]
          }
          footerStyle={{ textAlign: 'end' }}
        >
          <SimpleForm
            {...{
              isView: this.state.isView,
              children: this.config,
              onSubmitForm: this.onSubmitForm,
              onCloseModal: this.handleOk,
              dispatch: this.props.dispatch,
              id: id,
              apiData: this.state.apiData,
            }}
          />
        </Drawer>
      </>
    );
  };

  getImportModal = (form: any) => {
    const { isImportVisible, loading } = this.state;
    const { maskClosable } = this.config;
    return (
      <>
        <Drawer
          maskClosable={maskClosable}
          width={1000}
          title={'Import'}
          placement="right"
          onClose={this.handleImportCancel}
          open={isImportVisible}
          destroyOnClose={true}
          footer={
            [
              <Button
                key="back"
                onClick={() => {
                  this.props.dispatch({
                    apiData: null,
                    formData: null,
                    type: 'USER_FORM_DATA',
                  });
                  this.setState({
                    fixFilterData: {}
                  }, () => {
                    this.handleImportCancel();
                    this.getResponse();
                  });
                }}
                className="mr-2"
              >
                Clear
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={() => {
                  this.submitImportForm();
                }}
              >
                Continue
              </Button>,
            ]
          }
          footerStyle={{ textAlign: 'end' }}
        >
          <SimpleForm
            {...{
              isView: false,
              children: form,
              onSubmitForm: this.onSubmitImport,
              onCloseModal: this.handleImportCancel,
              dispatch: this.props.dispatch,
              id: 1,
              showResult: true
              // apiData: this.state.fixFilterData,
            }}
          />
        </Drawer>
      </>
    );
  };


  getFilterModal = (form: any) => {
    const { filterVisible, loading } = this.state;
    const { maskClosable } = this.config;
    return (
      <>
        <Drawer
          maskClosable={maskClosable}
          width={1000}
          title={'Filter'}
          placement="right"
          onClose={this.handleFilterCancel}
          open={filterVisible}
          destroyOnClose={true}
          footer={
            [
              <Button
                key="back"
                onClick={() => {
                  this.props.dispatch({
                    apiData: null,
                    formData: null,
                    type: 'USER_FORM_DATA',
                  });
                  this.setState({
                    fixFilterData: {}
                  }, () => {
                    this.handleFilterCancel();
                    this.getResponse();
                  });
                }}
                className="mr-2"
              >
                Clear Filter
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={() => {
                  this.setState({
                    fixFilterData: this.submitFilterForm
                  }, () => {
                    this.getResponse();
                    this.handleFilterCancel();
                  });
                }}
              >
                Search
              </Button>,
            ]
          }
          footerStyle={{ textAlign: 'end' }}
        >
          <SimpleForm
            {...{
              isView: false,
              children: form,
              onSubmitForm: this.onSubmitFilterForm,
              onCloseModal: this.handleFilterCancel,
              dispatch: this.props.dispatch,
              id: 1,
              apiData: this.state.fixFilterData,
              onFilterData: this.onFilterForm
            }}
          />
        </Drawer>
      </>
    );
  };


  getColumnSearchProps = (dataIndex, row) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) => {
      if (this.state.searchedColumn === dataIndex) {
        return row && row['render'] ? row.render(text) : text;
      } else {
        return row && row['render'] ? row.render(text) : text;
      }
    },
  });

  onEdit = (id) => {
    this.setState({ actionType: 'Edit' });
    this.getRecordsById(id);
  };

  onPDFGet = (data, row, buttonVisible = false, ele: any = null) => {
    this.setState({
      visiblePDF: true,
      buttonVisible: !buttonVisible,
      file: data,
      id: row._id,
      apiData: row,
      buttonText: (ele && ele.buttonText) ? ele.buttonText : null,
      keyDisabled: (ele && ele.keyDisabled) ? ele.keyDisabled : null,
      isButtonHide: ele.isButtonHide
    });
  };

  onView = (id) => {
    this.setState({ actionType: 'View' });
    this.getRecordsById(id, true);
  };

  onDelete = async (id) => {
    const response = await this.props.dispatch(
      deleteRow(`${this.config.api()}/${id}`)
    );
    if (response.code !== 0) {
      this.showNotification(
        'success',
        'Success',
        'Record Successfully deleted'
      );
      this.getResponse();
    } else {
      this.showNotification('error', 'Error', 'Something Went wrong');
    }
  };

  showDeleteConfirm = (id) => {
    const scope = this;
    confirm({
      title: 'Are you sure want delete this?',
      icon: <ExclamationCircleOutlined />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        scope.onDelete(id);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  checkAproval = (data) => {
    // Allow config to override checkAproval
    if (this.config && typeof this.config.checkAproval === 'function') {
      return this.config.checkAproval(data, this.props.user);
    }

    if (data && data.approvalStatus == 'APPROVED' && this.props.user && (data.approvalFrom !== this.props.user._id && this.props.user.designation !== 'Admin')) {
      return false;
    } else {
      return true;
    }
  };

  checkDelete = (data) => {
    // Allow config to override checkDelete
    if (this.config && typeof this.config.checkDelete === 'function') {
      return this.config.checkDelete(data, this.props.user);
    }

    if (data && data.approvalStatus == 'APPROVED' && this.props.user && (data.approvalFrom !== this.props.user._id && this.props.user.designation !== 'Admin')) {
      return false;
    } else if (this.props.user && (data.addedBy == this.props.user._id || this.props.user?.designation == 'Admin')) {
      return true;
    } else {
      return false;
    }
  };

  checkAprovalSendMail = (data) => {
    if (data && data.approvalStatus == 'APPROVED' || (this.props.user && (data.approvalFrom == this.props.user._id) || (this.props.user?.designation == 'Admin'))) {
      return true;
    } else {
      return false;
    }
  };


  getButtons = (text, row, index) => {
    console.log(text, index);
    const { moreActions } = this.config;
    const access = this.getAccess();
    const menu = (
      <Menu>
        <Menu.Item onClick={() => this.onView(row._id)}>View</Menu.Item>
        {access && access.edit && this.checkAproval(row) && (
          <Menu.Item onClick={() => this.onEdit(row._id)}>Edit</Menu.Item>
        )}
        {moreActions &&
          moreActions.map((ele) => (
            <Menu.Item
              onClick={() =>
                this.onPDFGet(ele.getKey(row), row, ele.noActionRequired, ele)
              }
              key={ele.name}
            >
              {ele.name}
            </Menu.Item>
          ))}
        {access && access.edit && this.checkAproval(row) && this.checkDelete(row) && (
          <Menu.Item onClick={() => this.showDeleteConfirm(row._id)}>
            Delete
          </Menu.Item>
        )}
      </Menu>
    );
    return (
      <Space size="middle">
        <Dropdown overlay={menu}>
          <a>
            More <DownOutlined />
          </a>
        </Dropdown>
      </Space>
    );
  };

  getText = async () => {
    // const { callAPI, key, filter, name } = actions
    // const responseData = await this.props.dispatch(getData(`${this.config.api()}${callAPI}`, filter));
    return (
      <Space size="middle">
        Shubham : 4545
        {/* {name}: {responseData[key]}sdsds */}
      </Space>
    );
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  filterData = (value) => {
    console.log('valuevaluevaluevaluevalue', value);
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  getFilter = (filter) => {
    this.getResponse({ startDate: filter[0], endDate: filter[1] });
  };

  onCurrentPageDataChange = (event) => {
    console.log('eventevent', event);
    const { current, pageSize, total } = event;
    this.setState({ pagination: { current, pageSize, total } });
    this.getResponse({ current, pageSize });
  };


  getAccess = () => {
    let currentPage = [];
    if (this.props.user?.designation == 'Admin') {
      currentPage = [{ create: true, view: true, edit: true }];
    } else {
      currentPage = this.props?.user?.access?.filter(
        (ele) => ele?.routing?.routeUrl == this.props?.match?.path
      );
    }
    return currentPage && currentPage.length > 0 ? currentPage[0] : {};
  };

  onClickComponentView(component) {
    this.DaynamicCompoent = component;
    this.setState({ isCoponentView: true });
  }

  getModelForDyanamic() {
    return <Drawer
      maskClosable={false}
      width={'80%'}
      title={'View'}
      placement="right"
      onClose={() => this.setState({ isCoponentView: false })}
      open={this.state.isCoponentView}
      destroyOnClose={true}
      footer={
        [
          <Button
            key="back"
            onClick={() => {
              this.setState({ isCoponentView: false });
            }}
            className="mr-2"
          >
            Close
          </Button>,
        ]
      }
      footerStyle={{ textAlign: 'end' }}
    >
      {this.DaynamicCompoent}
    </Drawer>;
  }

  renderMethod() {
    const { getColumns, actions, isActionTab, title, getExtraComponent } = this.config;
    const { columnData, pagination, isLoading } = this.state;
    const columnFields = [];
    if (isActionTab) {
      columnFields.push({
        title: 'Actions',
        dataIndex: 'Actions',
        key: 'Actions',
        fixed: 'left',
        width: 90,
        render: (text, row, index) => this.getButtons(text, row, index),
      });
    }

    getColumns().forEach((element) => {
      if (element.isSearch) {
        columnFields.push({
          ...element,
          // ...this.getColumnSearchProps(element.key, element),
          ellipsis: true
        });
      } else {
        if (element && element.type == 'file') {
          columnFields.push({
            ...element,
            ellipsis: true,
            render: (text) => (
              <Image
                width={element.width || 100}
                src={process.env.FILE_URL + text}
              />
            ),
          });
        } else if (element && element.type == 'viewList') {
          columnFields.push({
            ...element,
            ellipsis: true,
            render: (text) => {
              return (
                <EyeTwoTone
                  style={{ fontSize: '17px', display: 'flex', justifyContent: 'center' }}
                  onClick={() =>
                    this.setState({
                      filterdArray: element.render(text),
                      htmlText: element.render(text),
                      visibleText: true,
                    })
                  }
                />
              );
            },
          });
        } else if (element && element.type == 'viewText') {
          columnFields.push({
            ...element,
            ellipsis: true,
            render: (text) => {
              return (
                <EyeTwoTone
                  style={{ fontSize: '17px', display: 'flex', justifyContent: 'center' }}
                  onClick={() =>
                    this.setState({
                      filterdArray: element.render(text),
                      htmlText: element.render(text),
                      visibleText: true,
                    })
                  }
                />
              );
            },
          });
        } else if (element && element.type == 'renderHtml') {
          columnFields.push({
            ...element,
            ellipsis: true,
            render: (text) => {
              return (
                <div
                  dangerouslySetInnerHTML={{ __html: element.render(text) }}
                ></div>
              );
            },
          });
        } else if (element && element.type == 'renderComponent') {
          columnFields.push({
            ...element,
            ellipsis: true,
            render: (text) => element.render(text, (e) => this.onClickComponentView(e))
          });
        } else {
          columnFields.push({ ...element, ellipsis: true, });
        }
      }
    });

    const controls = [];
    if (actions.length > 0) {
      controls.push(
        <Search
          name="Search"
          placeholder="Search..."
          {...actions.settings}
          onInput={async (e: any) => {
            this.getResponse({ search: e.target.value });
          }}
        />
      );
      controls.push(
        <Button
          {...actions.settings}
          onClick={async () => {
            this.getResponse();
          }}
        >
          Refresh
        </Button>
      );
      actions.forEach((element) => {
        if (element && element.isImport) {
          controls.push(
            <Button
              onClick={async () => {
                this.props.dispatch({
                  apiData: null,
                  formData: null,
                  type: 'USER_FORM_DATA',
                });
                this.setState({ isImportVisible: true });
              }}
            >
              <div style={{ display: 'flex' }}>
                {element.name}
              </div>
            </Button>
          );
        } else if (element && element.isFilter && element.date) {
          controls.push(<RangePicker onChange={this.getFilter} />);
        } else if (element && element.isFilter && element.isDropDown) {
          const { selectedValue } = this.state;
          const options = [{ label: 'shubham', value: 'shubham' }];
          let mode;
          if (element.mode === 'single') {
            mode = 'single' as const;
          } else {
            mode = 'multiple' as const;
          }
          const selectProps = {
            mode,
            selectedValue,
            options,
            style: { width: '200px' },
            onChange: (newValue: string[]) => {
              this.setState({ selectedValue: newValue });
              this.filterData(newValue);
            },
            placeholder: 'Select Item...',
            maxTagCount: 'responsive' as const,
          };
          controls.push(<Select {...selectProps} />);
        } else if (element && element.otherFilter) {
          controls.push(
            <Button
              onClick={async () => {
                this.props.dispatch({
                  apiData: this.state.fixFilterData,
                  formData: this.state.fixFilterData,
                  type: 'USER_FORM_DATA',
                });
                this.setState({ filterVisible: true });
              }}
            >
              <div style={{ display: 'flex' }}>
                {Object.keys(this.state.fixFilterData).length ? <div className="indicator"></div> : <></>}
                {element.name}
              </div>
            </Button>
          );
        } else if (element.callAPI) {
          controls.push(
            <Button
              {...actions.settings}
              onClick={async () => {
                this.callAPI(element.callAPI, element.method);
              }}
            >
              {element.name}
            </Button>
          );
        } else {
          const access = this.getAccess();
          if (element.isModal) {
            if (access && access.create) {
              controls.push(
                <Button
                  {...actions.settings}
                  onClick={async () => {
                    this.props.dispatch({
                      apiData: null,
                      formData: null,
                      type: 'USER_FORM_DATA',
                    });
                    this.setState({ actionType: 'Add' });
                    if (element.isBack) {
                      return this.props.history.goBack();
                    }
                    if (element.isModal) {
                      this.showModal();
                    }
                  }}
                >
                  {element.name}
                </Button>
              );
            }
          } else {
            controls.push(
              <Button
                {...actions.settings}
                onClick={async () => {
                  this.props.dispatch({
                    apiData: null,
                    formData: null,
                    type: 'USER_FORM_DATA',
                  });
                  this.setState({ actionType: 'Add' });
                  if (element.isBack) {
                    return this.props.history.goBack();
                  }
                  if (element.isModal) {
                    this.showModal();
                  }
                }}
              >
                {element.name}
              </Button>
            );
          }
        }
      });

    }
    return (
      <>
        <ViewWrapper
          {...{
            requireAuth: true,
            title: title,
            isNotRedirected: true,
          }}
        >
          <Space direction='vertical' style={{ width: '100%' }}>
            <ViewHeading controls={controls} isSmall={true}>
              {this.config.title}
            </ViewHeading>
            {getExtraComponent && getExtraComponent()}
            {this.getModelForDyanamic()}
            {actions.map((ele) => {
              if (ele.isModal) {
                return this.getModal();
              }
              if (ele.otherFilter) {
                return this.getFilterModal(ele.form);
              }
              if (ele.isImport) {
                return this.getImportModal(ele.form);
              }
            })}
            {this.openPDF()}
            {this.viewText()}
            <div className="column" style={{ paddingTop: '0%' }}>
              <Table
                size='small'
                scroll={{ y: 650 }}
                bordered={true}
                loading={isLoading}
                columns={columnFields}
                dataSource={columnData}
                pagination={{ ...pagination, pageSizeOptions: ['18', '50', '100', '200'] }}
                onChange={(e) => this.onCurrentPageDataChange(e)}
              />
            </div>
          </Space>
        </ViewWrapper>
      </>
    );
  }



  onSearch = (array, value: any) => {
    const filterd = array.filter(ele => ele.includes(value.target.value));
    this.setState({ filterdArray: filterd });
  };


  getList = (text) => {
    return <div>
      <div className="listSearch">
        <div className="listText">
          <span>Total - ( {this.state.filterdArray.length} / {text.length} )</span>
        </div>
        <div>
          <Space.Compact size="small">
            <Search placeholder="Search" onChange={(e) => this.onSearch(text, e)} />
          </Space.Compact>
        </div>
      </div>
      <List
        bordered
        dataSource={this.state.filterdArray}
        renderItem={(item: any) => (
          <List.Item>
            <>{item}</>
          </List.Item>
        )}
      />
    </div>;
  };


  render() {
    return this.renderMethod();
  }
}

export default BaseComponent;